<template>
    <div class="templete_box">
        <div class="financeBox">
            <img class="financeImg" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/pc/%E8%9E%8D%E8%B5%84%E7%AE%A1%E7%90%86%402x.png" alt="">
        </div>
    </div>
</template>
<style scoped lang="scss">
.templete_box{text-align: left;}
.financeBox{overflow-y: auto;height: 100%;padding-bottom: 40px;background-color: #fff;}
.financeImg{width: 780px;}

</style>
<script>
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    export default {
        components:{
            tabletem,
            pagination
        },
        data(){
            return{
                
            }
        },
        created(){
           
        },
        methods:{
          
        },
        watch:{
            
        }
    }
</script>
